import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Form, Input, notification, Popover, Row, Select, Space, Spin, Table } from 'antd'
import _, { sum } from 'lodash'
import moment from 'moment'
import React, { ReactElement, useContext, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import styles from './peddingMedicalTreatment.module.css'
import { ThemeContext } from '../../../theme/ThemeContext'
import { ListItem } from './listItem'
import { FilterIconOutlined } from '../../../compnents/icons/Icons'
import { DateRangeType, DateSelect, getDateRange } from '../../../compnents/form/DateSelect'
import { PatientDetailMessage } from './patientDetailMessage'
import { RecipeListItem } from './recipeListItem'
import { getPeddingMedicalTreatmentDetail, getPeddingMedicalTreatmentList, getXMPageList } from './peddingMedicalTreatmentSlice'
import { DateTimeFormatSimple, DateTimeFormatSimpleOnly } from '../../../models/datetime'
import { CloseOutlined } from '@ant-design/icons'

export const PeddingMedicalTreatment = (props: {
  patientId?: string
  selectTabKey?: string
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const { Option } = Select

  const [form] = Form.useForm()

  const [popoverForm] = Form.useForm()

  const [open, setOpen] = useState(false)

  const [detail, setDetail] = useState<any>({})

  const [patientList, setPatientList] = useState<any[]>([])

  const [selectId, setSelectId] = useState<any>()

  const [registrationId, setRegistrationId] = useState<any>()

  const [head, tail] = getDateRange(DateRangeType.Today)

  const [params, setParams] = useState<any>()

  const [pageLoading, setPageLoading] = useState(false) // 表格 loading

  const [treatmentServiceNameList, setTreatmentServiceNameList] = useState<any[]>([])

  const [rightDataList, setRightDataList] = useState<any[]>([])

  const getFormatTime = (time: any) => {
    return moment(time).format(DateTimeFormatSimpleOnly)
  }

  const getFormatTimes = (time: any) => {
    return moment(time).format(DateTimeFormatSimple)
  }

  // 获取左侧患者列表
  const getLeftPatientList = () => {
    dispatch(getPeddingMedicalTreatmentList({
      ...params,
      current: 1,
      size: 30,
      state: 0,
      startTime: params?.startTime ? getFormatTime(params.startTime) : getFormatTime(head),
      endTime: params?.endTime ? getFormatTime(params.endTime) : getFormatTime(tail),
    }))
      .then(unwrapResult)
      .then((res: any) => {
        if (res?.records?.length) {
          setPatientList(res.records)
        } else {
          resetData()
          setPageLoading(false)
        }
      })
      .catch(() => {
        setPageLoading(false)
      })
  }


  useEffect(() => {
    if (registrationId) {
      getRightContent()
    }
  }, [registrationId])

  useEffect(() => {
    if (patientList?.length) {
      const flag = patientList?.filter((item: any) => item?.id == selectId).length
      setDetail(flag ? detail : patientList[0])
      setSelectId(flag ? selectId : patientList[0]?.id)
      setRegistrationId(flag ? detail?.registrationId : patientList[0]?.registrationId)
    }
  }, [patientList, selectId])

  const getRightContent = () => {
    setPageLoading(true)
    dispatch(getPeddingMedicalTreatmentDetail({
      state: 0,
      startTime: params?.startTime ? getFormatTime(params.startTime) : getFormatTime(head),
      endTime: params?.endTime ? getFormatTime(params.endTime) : getFormatTime(tail),
      registrationId: registrationId,
    }))
      .then(unwrapResult)
      .then((res: any) => {
        setRightDataList(res)
      })
      .catch(() => {
        // do nothing
      })
      .finally(() => {
        setPageLoading(false)
      })
  }

  useEffect(() => {
    if (props?.selectTabKey == '0') {
      resetData()
      setPageLoading(true)
      getLeftPatientList()
    }
  }, [params, props?.selectTabKey])

  const getXMList = (startTime?: any, endTime?: any) => {
    dispatch(getXMPageList({
      state: 0,
      startTime: startTime ? getFormatTime(startTime) : getFormatTime(head),
      endTime: endTime ? getFormatTime(endTime) : getFormatTime(tail),
    }))
      .then(unwrapResult)
      .then((res: any) => {
        setTreatmentServiceNameList(res)
      })
      .catch(() => {
        // do nothing
      })
  }

  useEffect(() => {
    if (props?.selectTabKey == '0') {
      getXMList(head, tail)
    }
  }, [props?.selectTabKey])

  const resetData = () => {
    setPatientList([])
    setRightDataList([])
    setDetail({})
    setSelectId('')
    setRegistrationId('')
  }

  return (
    <>
      <Col
        className={styles.peddingMedicalTreatmentContainer}
      >
        <div className={styles.content} >
          {/* 左侧页面 */}
          <div
            style={{ backgroundColor: theme.pn }}
            className={styles.leftContent}
          >
            {/* 查询 */}
            <Form
              form={form}
              onFinish={(val) => {
                setPageLoading(true)
                resetData()
                setParams({
                  ...params,
                  ...val,
                })
              }}>
              <Row style={{ marginBottom: 10, padding: '0 15px' }}>
                <Form.Item name='keyword' noStyle>
                  <Input
                    size='middle'
                    placeholder='患者姓名/手机号/病历号'
                    maxLength={20}
                    style={{ width: '196px' }}
                    allowClear
                    onChange={(() => {
                      form.submit()
                    })}
                  />
                </Form.Item>
                <Popover
                  visible={open}
                  overlayClassName={styles.formQueryPopover}
                  onVisibleChange={(v) => {
                    setOpen(v)
                  }}
                  content={
                    <>
                      <Form
                        form={popoverForm}
                        onFinish={(val) => {
                          setPageLoading(true)
                          resetData()
                          setOpen(false)
                          setParams({
                            ...params,
                            ...val,
                            startTime: val?.timeHead ? val?.timeHead : getFormatTime(head),
                            endTime: val?.timeTail ? val?.timeTail : getFormatTime(tail),
                            timeHead: undefined,
                            timeTail: undefined,
                          })
                        }}
                      >
                        <div className={styles.filterItem}>
                          <div className={styles.filterTitle}>开单日期</div>
                          <Form.Item name='' noStyle>
                            <DateSelect
                              styleFlag={true}
                              placeholder='时间范围'
                              style={{ width: '100%' }}
                              onChange={((v: any, dateValue: any) => {
                                if (dateValue?.[0] && dateValue?.[1]) {
                                  getXMList(dateValue?.[0], dateValue?.[1])
                                }
                              })}
                              initialValue={DateRangeType.Today}
                              labelPrefix=''
                              namePrefix='time'
                              allowClear={false}
                            />
                          </Form.Item>
                          <div className={styles.filterTitle}>项目</div>
                          <Form.Item name='treatmentServiceId' noStyle>
                            <Select
                              placeholder='项目'
                              style={{ width: '100%' }}
                              allowClear
                              onChange={(() => {
                                return
                              })}
                            >
                              {treatmentServiceNameList?.map((v) => (
                                <Option key={v.id} value={v.id}>
                                  {v.name}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                        <Space
                          style={{
                            display: 'flex',
                            justifyContent: 'end',
                            marginTop: '10px',
                          }}
                        >
                          <Button
                            size='middle'
                            type={'ghost'}
                            onClick={() => {
                              popoverForm.resetFields()
                              setOpen(false)
                              setParams({
                                ...params,
                                startTime: getFormatTime(head),
                                endTime: getFormatTime(tail),
                              })
                              getXMList(getFormatTime(head), getFormatTime(tail))
                            }}
                          >
                            取消
                          </Button>
                          <Button size='middle' type='primary' htmlType='submit'>
                            确定
                          </Button>
                        </Space>
                      </Form>
                    </>
                  }
                  title=''
                  trigger='click'
                  placement='bottom'
                >
                  <Form.Item name='' initialValue={'筛选'} noStyle>
                    <Button
                      style={{
                        color: theme.tc2,
                      }}
                      className={styles.filterButton}
                      icon={
                        <FilterIconOutlined
                          className={styles.filterIcon}
                        />
                      }
                      onClick={() => {
                        setOpen(true)
                      }}
                    >
                      筛选
                    </Button>
                  </Form.Item>
                </Popover>
              </Row>
            </Form>
            <div style={{ marginBottom: '10px' }}>
              <div className={styles.filterText}>
                <span className={styles.leftText}>开单日期：{getFormatTimes(params?.startTime)} ~ {getFormatTimes(params?.endTime)}</span>
                <span
                  onClick={() => {
                    setParams({
                      ...params,
                      startTime: getFormatTimes(head),
                      endTime: getFormatTimes(tail),
                    })
                    popoverForm.setFieldsValue({
                      _dateRange: DateRangeType.Today,
                      timeHead: head,
                      timeTail: tail,
                    })
                  }}>
                  <CloseOutlined></CloseOutlined>
                </span>
              </div>
              {params?.treatmentServiceId &&
                <div className={styles.filterText}>
                  <span className={styles.leftText}>项目：{treatmentServiceNameList?.find((v) => v.id == params?.treatmentServiceId)?.name}</span>
                  <span
                    onClick={() => {
                      setParams({
                        ...params,
                        treatmentServiceId: null,
                      })
                      popoverForm.setFieldsValue({
                        treatmentServiceId: null,
                      })
                    }}>
                    <CloseOutlined></CloseOutlined>
                  </span>
                </div>}
            </div>
            {/* 展示患者信息 */}
            <div className={styles.listContent}>
              {patientList?.length !== 0 &&
                patientList.map((el: any, index: number) => (
                  <ListItem
                    selectId={selectId}
                    data={el}
                    key={el.id}
                    onClick={(el) => {
                      setSelectId(el?.id)
                      setRegistrationId(el?.registrationId)
                      setDetail(el)
                    }}
                  />
                ))}
            </div>
          </div>
          <div
            style={{ backgroundColor: theme.pn }}
            className={styles.rightContent}
          >
            {/* 展示患者详情 */}
            <PatientDetailMessage
              detail={detail}
            ></PatientDetailMessage>
            <div className={styles.recipelistItemBottoMain}>
              <RecipeListItem
                loading={pageLoading}
                patientId={detail?.patientId}
                selectTabKey={props?.selectTabKey}
                data={rightDataList}
                refresh={(() => {
                  setRegistrationId(null)
                  getLeftPatientList()
                })}
              />
            </div>
          </div>
        </div>
      </Col >
    </>
  )
}
